/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useEffect,
    useState,
    useContext,
    Fragment,
    useCallback,
    useRef,
} from "react";
import DndRow from "./DndRow.jsx";
import { Table, Modal, Button as ButtonComponent } from "react-bootstrap";
import PropTypes from "prop-types";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import update from "immutability-helper";
import { useAxios } from "utils/CustomHooks";
import { isEmpty } from "lodash";
import {
    Button,
    Toast,
    Pagination,
    Status,
    FinancialStatus,
    CloseFinancialCycle,
    ResponseHandler,
} from "components";
import { UserDataContext } from "store/UserContext.jsx";
import { ReactComponent as EditIcon } from "assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "assets/icons/delete.svg";
import { ReactComponent as BarcodeIcon } from "assets/icons/barcode.svg";
import { ReactComponent as RestoreIcon } from "assets/icons/restore.svg";
import { ReactComponent as UploadIcon } from "assets/icons/upload.svg";
import { Link, useHistory } from "react-router-dom";
import "./kitchenTableList.scss";

const KitchenTableList = ({
    list,
    url,
    pageName,
    fetchNewList,
    rowLinkUrl,
    isView,
    data,
    withDnd,
}) => {
    const history = useHistory();
    const [fetchData, setFetchParams] = useAxios();
    const [deleteResponse, setDeleteResponse] = useAxios();
    const [fetchFoodDelivery, setFoodDelivery] = useAxios();
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState("");
    const [userData] = useContext(UserDataContext);
    const [tableData, setTableData] = useState([]);

    const {
        response: records,
        error: recordsError,
        loading: recordsLoading,
    } = url
        ? fetchData
        : data || { response: null, loading: false, error: false };

    const prevDataRef = useRef([]);

    useEffect(() => {
        setFetchParams({
            method: "get",
            url: url,
            params: fetchNewList,
        });
    }, [
        deleteResponse && deleteResponse.response,
        fetchFoodDelivery && fetchFoodDelivery.response,
    ]);

    useEffect(() => {
        setFetchParams({
            method: "get",
            url: url,
            params: fetchNewList,
        });
    }, [fetchNewList && Object.values(fetchNewList).length > 0, fetchNewList]);

    useEffect(() => {
        if (records) {
            setTableData(records?.data);
        }
    }, [records]);

    const {
        response: deleteResponseStatus,
        loading: deleteLoading,
        error: deleteError,
    } = deleteResponse;

    const handleDelete = (item, action, modalText) => {
        setShowModal(true);
        setCurrentItem({ ...item, action: action, modalText: modalText });
    };

    const handleBarcode = (item) => {
        window.open(`https://api.snappkitchen.ir/barcode/generate/${item.id}`);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const confirmDelete = (item) => {
        setShowModal(false);
        setDeleteResponse({
            method: "delete",
            url: `${url}/${item.id}`,
        });
    };

    const confirmRestore = (item) => {
        setShowModal(false);
        setDeleteResponse({
            method: "post",
            url: `${url}/${item.id}`,
        });
    };

    const confirmDelivery = (item) => {
        setShowModal(false);
        setFoodDelivery({
            url: url,
            method: "put",
            data: {
                order_number: item.order_number,
                status: 2,
            },
        });
    };

    const updateCycleList = () => {
        history.go(0);
    };

    const handleFoodDelivery = (item, action, modalText) => {
        setShowModal(true);
        setCurrentItem({ ...item, action: action, modalText: modalText });
    };

    // const tableData = records && records.data;

    const role = userData?.role;

    const handleActions = (actions, item) => {
        if (pageName === "financial-period") {
            if (item.status === 2) {
                return (
                    <Link
                        to={{
                            pathname: `/financial-period/${item.id}`,
                            params: item.id,
                            state: item,
                        }}
                        className="kitchen-btn show-detail-btn bordered is-pink"
                    >
                        نمایش جزییات
                    </Link>
                );
            } else {
                return actions.map((action) => {
                    switch (action) {
                        case "edit":
                            return role === "admin" || role === "superadmin" ? (
                                <Link
                                    to={{
                                        pathname: `/update-${pageName}/${item.id}`,
                                        state: item,
                                    }}
                                    className="edit-btn"
                                >
                                    <EditIcon data-testid="edit-icon" />
                                </Link>
                            ) : null;
                        case "close":
                            return role === "admin" || role === "superadmin" ? (
                                <CloseFinancialCycle
                                    cycleId={item.id}
                                    updateCycleList={updateCycleList}
                                    title={item.title}
                                />
                            ) : null;
                        case "upload":
                            return role === "admin" || role === "superadmin" ? (
                                <Link
                                    to={{
                                        pathname: `/financial-period/${item.id}`,
                                        params: { id: item.id },
                                        state: item,
                                    }}
                                    className="upload-btn"
                                >
                                    <UploadIcon data-testid="upload-icon" />
                                </Link>
                            ) : (
                                <Link
                                    to={{
                                        pathname: `/financial-period/${item.id}`,
                                        params: item.id,
                                        state: item,
                                    }}
                                    className="show-detail-btn kitchen-btn bordered is-green"
                                >
                                    نمایش جزییات
                                </Link>
                            );
                        case "delete":
                            return (
                                <DeleteIcon
                                    className="delete-btn"
                                    onClick={() =>
                                        handleDelete(item, "delete", "حذف")
                                    }
                                />
                            );

                        default:
                            break;
                    }
                });
            }
        } else {
            return actions.map((action) => {
                switch (action) {
                    case "edit":
                        return (
                            <>
                                {pageName !== "financial-period" ||
                                (pageName === "financial-period" &&
                                    (role === "admin" ||
                                        role === "kitchen")) ? (
                                    <Link
                                        to={{
                                            pathname: isView
                                                ? `/view-${pageName}/${item.id}`
                                                : `/update-${pageName}/${item.id}`,
                                            state: item,
                                        }}
                                        className="edit-btn"
                                        target="_blank"
                                    >
                                        <EditIcon data-testid="edit-icon" />
                                    </Link>
                                ) : null}
                            </>
                        );
                    case "update":
                        return (
                            <ButtonComponent
                                variant="success"
                                disabled={item.status === 1 ? false : true}
                                onClick={() =>
                                    handleFoodDelivery(
                                        item,
                                        "update",
                                        "تحویل غذای"
                                    )
                                }
                            >
                                تحویل
                            </ButtonComponent>
                        );
                    case "close":
                        return role === "admin" || role === "kitchen" ? (
                            <CloseFinancialCycle
                                cycleId={item.id}
                                updateCycleList={updateCycleList}
                                title={item.title}
                            />
                        ) : null;
                    case "upload":
                        return (
                            <Link
                                to={{
                                    pathname: `/financial-period/${item.id}`,
                                    params: { id: item.id },
                                    state: item,
                                }}
                                className="upload-btn"
                            >
                                <UploadIcon data-testid="upload-icon" />
                            </Link>
                        );
                    case "delete":
                        return (
                            <>
                                {!isView && (
                                    <DeleteIcon
                                        className="delete-btn"
                                        onClick={() =>
                                            handleDelete(item, "delete", "حذف")
                                        }
                                    />
                                )}
                            </>
                        );
                    case "barcode":
                        if (item.barcode !== "") {
                            return (
                                <BarcodeIcon
                                    className="barcode-btn"
                                    onClick={() =>
                                        handleBarcode(item, "barcode")
                                    }
                                />
                            );
                        } else {
                            return null;
                        }
                    case "restore":
                        return (
                            <RestoreIcon
                                className="restore-btn"
                                onClick={() =>
                                    handleDelete(item, "restore", "بازگردانی")
                                }
                            />
                        );
                    default:
                        break;
                }
            });
        }
    };

    const TableFields = ({ item }) => {
        return (
            <Fragment>
                {list.fields.map((field, i) => (
                    <td key={i} data-testid="TableList__TD">
                        {field["name"] !== "status" ? (
                            typeof item[field["name"]] !== "object" ? (
                                item[field["name"]]
                            ) : (
                                item[field["name"]].title
                            )
                        ) : pageName === "financial-period" ? (
                            <>
                                {role === "admin" || role === "kitchen" ? (
                                    <FinancialStatus
                                        statusType={item["status"]}
                                        title={item["status_str"]}
                                    />
                                ) : null}
                            </>
                        ) : (
                            <Status
                                statusType={item["status"]}
                                title={item["status_str"]}
                            />
                        )}
                    </td>
                ))}
                {!isEmpty(list.actions) && (
                    <td className="actions-cell">
                        {item.deleted_at
                            ? handleActions(["edit", "restore"], item)
                            : handleActions(list.actions, item)}
                    </td>
                )}
            </Fragment>
        );
    };

    const moveRow = useCallback(
        (dragIndex, hoverIndex) => {
            prevDataRef.current.push(tableData[dragIndex].sort);
            const dragCard = tableData[dragIndex];
            setTableData(
                update(tableData, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, dragCard],
                    ],
                })
            );
        },
        [tableData]
    );

    const dropRow = (dropItem) => {
        const data = {
            id: dropItem.id,
            vendor_id: dropItem.vendor_id,
            old_sort: prevDataRef.current[0],
            new_sort: records.data[dropItem.index].sort,
        };
        if (data.old_sort !== data.new_sort) {
            setFetchParams({
                method: "put",
                url: url + "/sort",
                params: {
                    ...fetchNewList,
                    page: records.current_page,
                    pageSize: records.per_page,
                },
                data: data,
            });
        }
        prevDataRef.current = [];
    };

    return (
        <div data-testid="table-container">
            {!showModal && !deleteLoading && !deleteError && (
                <Toast
                    className="success"
                    isShow={
                        deleteResponseStatus?.status === "OK" ? true : false
                    }
                    title={"آیتم با موفقیت حذف شد!"}
                />
            )}
            <ResponseHandler
                error={recordsError}
                loading={recordsLoading}
                response={tableData}
                noDataText="در حال حاضر آیتمی موجود نیست."
            >
                <DndProvider backend={HTML5Backend}>
                    <Table
                        bordered
                        hover
                        className="kitchen-list-container rtl"
                    >
                        <thead data-testid="table-head">
                            <tr>
                                {list?.fields.map((item) => (
                                    <th key={item.name}>{item.label}</th>
                                ))}
                                {!isEmpty(list?.actions) && <th>عملیات</th>}
                            </tr>
                        </thead>
                        <tbody data-testid="table-body">
                            {recordsError ? (
                                <tr>
                                    <td colSpan={list?.fields.length + 1}>
                                        خطا در بارگذاری اطلاعات
                                    </td>
                                </tr>
                            ) : null}
                            {!withDnd
                                ? tableData?.map((item, index) => (
                                      <tr
                                          key={item.uid}
                                          onClick={() =>
                                              rowLinkUrl &&
                                              pageName !== "financial-period" &&
                                              history.push({
                                                  pathname: `${rowLinkUrl}/${
                                                      item.id
                                                  }${
                                                      item.hub_id
                                                          ? "/" + item.hub_id
                                                          : ""
                                                  }`,
                                                  state: item,
                                              })
                                          }
                                      >
                                          <TableFields item={item} />
                                      </tr>
                                  ))
                                : tableData?.map((item, index) => (
                                      <DndRow
                                          key={item.uid}
                                          index={index}
                                          id={item.id}
                                          moveRow={moveRow}
                                          dropRow={dropRow}
                                          onClick={() =>
                                              rowLinkUrl &&
                                              pageName !== "financial-period" &&
                                              history.push({
                                                  pathname: `${rowLinkUrl}/${
                                                      item.id
                                                  }${
                                                      item.hub_id
                                                          ? "/" + item.hub_id
                                                          : ""
                                                  }`,
                                                  state: item,
                                              })
                                          }
                                      >
                                          <TableFields item={item} />
                                      </DndRow>
                                  ))}
                        </tbody>
                    </Table>
                </DndProvider>
                {records && (
                    <Pagination
                        totalCount={records.total}
                        pageSize={records.per_page}
                        currentPage={records.current_page}
                        onPageChange={(currentPage) =>
                            setFetchParams({
                                method: "get",
                                url: url,
                                params: {
                                    ...fetchNewList,
                                    page: currentPage,
                                    pageSize: records.per_page,
                                },
                            })
                        }
                    />
                )}
            </ResponseHandler>
            <Modal show={showModal} onHide={handleClose} data-testid="modal">
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body className="rtl">
                    {`آیا از
                    ${currentItem.modalText}
                    ${
                        currentItem.title ||
                        (currentItem.first_name &&
                            currentItem.first_name +
                                " " +
                                currentItem.last_name) ||
                        currentItem.customer_name
                    } اطمینان دارید؟`}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        btnText="انصراف"
                        className="bordered is-green"
                        handleClick={() => handleClose()}
                    />
                    <Button
                        btnText="تایید"
                        className="solid is-green"
                        handleClick={() =>
                            currentItem.action === "delete"
                                ? confirmDelete(currentItem)
                                : currentItem.action === "update"
                                ? confirmDelivery(currentItem)
                                : confirmRestore(currentItem)
                        }
                    />
                </Modal.Footer>
            </Modal>
        </div>
    );
};

KitchenTableList.propTypes = {
    pageName: PropTypes.string,
    list: PropTypes.object,
    url: PropTypes.string,
    fetchNewList: PropTypes.any,
    rowLinkUrl: PropTypes.string,
    withDnd: PropTypes.bool,
};

export default KitchenTableList;
